import {Main} from '../../components/main/main.tsx';
import {Page} from '../../components/page/page.tsx';
import {NewsItem} from './components/news_item.tsx';
import {PageContent} from '../../components/page/page_content.tsx';
import {useAppDispatch, useAppSelector} from '../../store/store.ts';
import {useIsNavigatingOrPending} from '../../support/use_is_navigating_or_pending.ts';
import {useCallback, useEffect, useState} from 'react';
import {fetchMoreNews, fetchNews} from '../../store/slices/news_slice.ts';
import {CenteredSpinner} from '../../components/spinner/centered_spinner.tsx';
import {FlexRow} from '../../components/utility/flex_row.tsx';
import {Alignment} from '../../enums/alignment.ts';
import {Button} from '../../components/button/button.tsx';
import {Status} from '../../enums/status.ts';
import {__} from '../../support/lang/translations.ts';

export function News() {
    const dispatch = useAppDispatch();
    const newsData = useAppSelector((state) => state.news);
    const isLoading = useIsNavigatingOrPending((state) => state.news.status);
    const resultsCount = newsData.newsPageInfo?.count ?? 0;
    const [page, setPageNumber] = useState(0);

    useEffect(() => {
        dispatch(
            fetchNews({
                page: page,
                limit: 20,
            }),
        );
    }, [dispatch, page]);

    const loadMorePossible =
        newsData.newsPageInfo != null &&
        newsData.newsPageInfo.count != null &&
        newsData.news != null &&
        newsData.newsPageInfo.count > newsData.news?.length;

    const onLoadMoreCallback = useCallback(() => {
        dispatch(
            fetchMoreNews({
                page: page + 1,
                limit: 20,
            }),
        );
        setPageNumber(page + 1);
    }, [dispatch, page]);

    return (
        <Main>
            <Page isLoading={isLoading}>
                <PageContent>
                    {(newsData.news == null || newsData.news?.length === 0) && <CenteredSpinner />}

                    {resultsCount > 0 &&
                        newsData.news?.map((n, index) => (
                            <NewsItem key={`news-${n?.id}`} newsItem={n} highlighted={index === 0} />
                        ))}
                    {loadMorePossible && (
                        <FlexRow alignment={Alignment.Center}>
                            <Button
                                disabled={!loadMorePossible || isLoading || newsData.status === Status.LOADING_MORE}
                                onClick={onLoadMoreCallback}
                                loading={isLoading || newsData.status === Status.LOADING_MORE}
                            >
                                <i className="fa-light fa-refresh" />
                                <span>
                                    {__(
                                        newsData.status === Status.LOADING_MORE
                                            ? 'news.index.buttons.loading'
                                            : 'news.index.buttons.more',
                                    )}
                                </span>
                            </Button>
                        </FlexRow>
                    )}
                </PageContent>
            </Page>
        </Main>
    );
}
